import { graphql, useStaticQuery } from "gatsby"

export const useSiteDefaultsQuery = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        ...SiteDefaultFragment
      }
    }
  `)
  return data?.site?.siteMetadata?.defaults
}
